<div style="background-color: #6995db; color: white; overflow: auto">
  <table style="
      border-collapse: collapse;
      text-align: center;
      width: 100%;
      font-size: 12px;
      background-color: #6995db;
      color: white;
    ">
    <thead>
      <tr style="background-color: #6995db; color: white;">
        <th
          *ngFor="let header of tableData?.headers"
          style="border: 1px solid white; padding: 4px; background-color: #6995db; color: white;"
        >
          {{ header }}
        </th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let row of tableData?.rows">
        <td
          *ngFor="let cell of row"
          style="border: 1px solid white; padding: 4px; background-color: #6995db; color: white;"
        >
          {{ cell }}
        </td>
      </tr>
    </tbody>
  </table>
</div>
